__turbopack_context__.v({
  "className": "alexandria_d7f2b3c6-module__Cg_Pqa__className",
});
